export default "__VITE_ASSET__CSmEvOsz__"